import * as types from '../../../actions'; 

const initialState = {
  skillItems: [],
  items: [],
  item: [],
  status:0,
  activity:''  
};

export default function(state = initialState, action) {
  const response = action.response; 
  let timeVar = '~~'+Date.now(); 
  
  switch(action.type) {
    
      case types.SKILL_SEL_LIST_AFFILIATE_SUCCESS:
        return {
            ...state,
            skillItems: response.data,
            status: response.status,
            activity: types.SKILL_SEL_LIST_AFFILIATE_SUCCESS+timeVar
        };
      case types.SKILL_SEL_LIST_AFFILIATE_ERROR:
          return {
              ...state,
              response
          };


      case types.STCBONUS_LIST_AFFILIATE_SUCCESS:
        return {
            ...state,
            skillItems: [...state.skillItems],
            items: response.data,
            status: response.status,
            activity:types.STCBONUS_LIST_AFFILIATE_SUCCESS+timeVar
        };
      case types.STCBONUS_LIST_AFFILIATE_ERROR:
        return {
            ...state,
            response
        };    

      
        case types.STCBONUS_ADD_AFFILIATE_SUCCESS:
            return {
            ...state,
            skillItems: [...state.skillItems],
            items: [...state.items],
            item: response.data, 
            status: response.status,
            activity:types.STCBONUS_ADD_AFFILIATE_SUCCESS+timeVar
            };
        case types.STCBONUS_ADD_AFFILIATE_ERROR:
            return {
            ...state,
            response
            };    
 

        case types.STCBONUS_UPDATE_AFFILIATE_SUCCESS:
            return {
                ...state,
                skillItems: [...state.skillItems],
                items:state.items.map(item => {
                  return item.id === response.data.id ? response.data : item;
                }),
                item: response.data, 
                status: response.status,
                activity:types.STCBONUS_UPDATE_AFFILIATE_SUCCESS+timeVar
            };
          case types.STCBONUS_UPDATE_AFFILIATE_ERROR:
            return {
                ...state,
                response
            };    


          case types.STCBONUS_DELETE_AFFILIATE_SUCCESS:                 
            return {
                skillItems: [...state.skillItems],
                items: [...state.items],
                item: [],
                status: response.status,
                activity:types.STCBONUS_DELETE_AFFILIATE_SUCCESS+timeVar
            };
          case types.STCBONUS_DELETE_AFFILIATE_ERROR:
            return {
                ...state,
                response
            };    

          
          case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name: '',
                },
                activity:'',
                status:0               
            }  


        default:
          return state;
  }
};
